import { useGlobalBridge } from '@beefco/bridge';
import { useBeefCoPage, useBeefCoProject } from '@beefco/sdk-shared';
import { InitLocalPageCommand, UpdateLocalProjectCommand } from '@beefco/sdk-tools';
import { DateISODto } from '@beefco/types';
import { useEffect } from 'react';
export var useUpdateLocalProject = function useUpdateLocalProject(_ref) {
  var pageId = _ref.pageId,
    pageSlug = _ref.pageSlug;
  var _useBeefCoProject = useBeefCoProject(),
    config = _useBeefCoProject.config;
  var globalBridge = useGlobalBridge();
  var _useBeefCoPage = useBeefCoPage(),
    coreDSL = _useBeefCoPage.coreDSL;
  useEffect(function () {
    var handleInit = function handleInit(_ref2) {
      var serverLibraryDsl = _ref2.libraryDSL,
        serverPageSlug = _ref2.pageSlug;
      if (pageSlug !== serverPageSlug) {
        return;
      }
      globalBridge.bus.execute(new InitLocalPageCommand({
        pageId: pageId,
        pageSlug: pageSlug,
        coreDSL: coreDSL,
        libraryDSL: serverLibraryDsl,
        config: config,
        updatedAt: DateISODto.toPlain(new Date())
      }));
    };
    globalBridge.bus.on(UpdateLocalProjectCommand, handleInit);
    return function () {
      globalBridge.bus.off(UpdateLocalProjectCommand, handleInit);
    };
  }, [pageSlug, globalBridge, pageId, coreDSL, config]);
};